import {inject, injectable} from 'inversify';

import {DeleteDiaryEntryCmd} from '../ports/DeleteDiaryEntry/DeleteDiaryEntry.cmd';

@injectable()
export class DeleteDiaryEntryUseCase {
  constructor(
    @inject(DeleteDiaryEntryCmd)
    private readonly cmd: DeleteDiaryEntryCmd,
  ) {}

  async exec(
    props: DeleteDiaryEntryUseCase.Props,
  ): Promise<DeleteDiaryEntryUseCase.Response> {
    return this.cmd.exec(props);
  }
}

export namespace DeleteDiaryEntryUseCase {
  export type Props = DeleteDiaryEntryCmd.Props;
  export type Response = DeleteDiaryEntryCmd.Response;
}
